import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "racq-dropdown" }
const _hoisted_2 = ["aria-expanded", "aria-controls"]
const _hoisted_3 = { class: "flex justify-between items-center w-full" }
const _hoisted_4 = ["id", "aria-activedescendant"]
const _hoisted_5 = ["aria-selected", "onClick"]

import { useUniqueId } from '@/utils/common-helper';
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'SelectMenu',
  props: {
    context: {}
  },
  setup(__props: any) {

const props = __props;

const isOpen = ref(false);
const selectedOption = ref(props.context?.value || null);
const highlightedIndex = ref(-1);
const dropdownId = useUniqueId('dropdown-menu');

const hasClassOption = (className: string) => props.context?.attrs?.classesOptions?.includes(className) || false;
const isSmall = computed(() => hasClassOption('dropdown-sm'));
const isDisabled = computed(() => hasClassOption('dropdown-disabled'));
const isTextMBold = computed(() => hasClassOption('text-m-bold'));
const isMenuAlignRight = computed(() => hasClassOption('dropdown-menu-align-right'));

const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};

const selectOption = (option: any) => {
  selectedOption.value = option.label;
  isOpen.value = false; // Close dropdown
  emitChange(option.value);
};

// Emit change to FormKit
const emitChange = (value: any) => {
  props.context?.node.input(value);
};

// Close dropdown when clicking outside
const closeDropdown = (e: MouseEvent) => {
  if (!(e.target as HTMLElement).closest('.racq-dropdown')) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', closeDropdown);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdown);
});

const onKeyDown = (e: KeyboardEvent) => {
  if (isDisabled.value) return;

  const total = props.context.options.length;

  if (!isOpen.value) {
    // Open dropdown on Enter or Space when focused
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // Prevent scrolling for Space
      isOpen.value = true;
      highlightedIndex.value = 0;
    }
    // Also support ArrowDown or ArrowUp for opening
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      isOpen.value = true;
      highlightedIndex.value = 0;
    }
    return;
  }

  // Navigation and selection
  switch (e.key) {
    case 'ArrowDown':
      highlightedIndex.value = (highlightedIndex.value + 1) % total;
      break;
    case 'ArrowUp':
      highlightedIndex.value = (highlightedIndex.value - 1 + total) % total;
      break;
    case 'Enter':
    case ' ':
      if (highlightedIndex.value >= 0) {
        e.preventDefault();
        selectOption(props.context.options[highlightedIndex.value]);
      }
      break;
    case 'Escape':
      isOpen.value = false;
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["racq-dropdown__button", {
        'racq-dropdown__button--sm': isSmall.value,
        'racq-dropdown__button--disabled': isDisabled.value,
      }]),
      role: "combobox",
      "aria-haspopup": "listbox",
      "aria-expanded": isOpen.value,
      "aria-controls": _unref(dropdownId),
      onClick: _withModifiers(toggleDropdown, ["stop"]),
      onKeydown: _withModifiers(onKeyDown, ["stop","prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'text-m-bold': isTextMBold.value })
        }, _toDisplayString(_ctx.context.attrs.keepPlaceHolder ? _ctx.context.attrs.placeholder : (selectedOption.value ?? _ctx.context.attrs.placeholder)), 3),
        (_openBlock(), _createElementBlock("svg", {
          class: _normalizeClass(["racq-dropdown__icon transition-all", {
            'racq-dropdown__icon--disabled': isDisabled.value,
            'rotate-180': isOpen.value,
          }]),
          width: "16",
          height: "16",
          viewBox: "0 0 16 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M3 5L8 10L13 5",
            stroke: "currentColor",
            "stroke-width": "2"
          }, null, -1)
        ]), 2))
      ])
    ], 42, _hoisted_2),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["racq-dropdown__menu", {
        'racq-dropdown__menu--sm': isSmall.value,
        'racq-dropdown__menu--align-right': isMenuAlignRight.value,
      }])
    }, [
      _createElementVNode("div", {
        id: _unref(dropdownId),
        class: "p-1",
        role: "listbox",
        "aria-activedescendant": `option-${highlightedIndex.value}`
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.context.options, (option, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            type: "button",
            role: "option",
            "aria-selected": index === highlightedIndex.value,
            class: _normalizeClass(["racq-dropdown__option", { 'bg-racq-anti-flash-white': index === highlightedIndex.value }]),
            onClick: _withModifiers(($event: any) => (selectOption(option)), ["stop"]),
            onKeydown: _withModifiers(onKeyDown, ["stop","prevent"])
          }, _toDisplayString(option.label), 43, _hoisted_5))
        }), 128))
      ], 8, _hoisted_4)
    ], 2), [
      [_vShow, isOpen.value && !isDisabled.value]
    ])
  ]))
}
}

})